export default "/_next/static/chunks/fonts/WhitneySSm-Black-Pro_Web-5a8bbc442fa7a1224a76a13c9bffeefa.woff";